import axios from "axios";
import { CONFIG } from "../config.js";
import { attachTransportErrorInterceptor } from "../errors/apiErrorBus";

const PLANS_URL = CONFIG.PLANS_BILLING_URL || "http://localhost:8000/api";
const AUTH_LAMBDA_URL = CONFIG.LAMBDA_URL || "http://localhost:8000/api";

/**
 * Plans Lambda (VPC / RDS only) — GET /plans.
 * CORS is Allow-Origin: *; do not send credentials.
 */
const plansClient = axios.create({
  baseURL: PLANS_URL,
  withCredentials: false,
});

/**
 * Auth Lambda (no VPC) — Cognito signup/login + signup-time Razorpay
 * (/billing/signup/*). In-app upgrade/renew uses Backend /api/billing/*
 * via axiosInstance (cookie session), not this client.
 * CORS is Allow-Origin: *; do not send credentials.
 */
const authBillingClient = axios.create({
  baseURL: AUTH_LAMBDA_URL,
  withCredentials: false,
});

attachTransportErrorInterceptor(plansClient, "plans-lambda");
attachTransportErrorInterceptor(authBillingClient, "auth-billing-lambda");

/** Normalize GET /plans payloads (array or { plans: [...] }). */
export const normalizePlansPayload = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.plans)) return data.plans;
  return [];
};

export const fetchPlans = (config = {}) =>
  plansClient.get("/plans", { timeout: 15000, ...config });

/** POST /billing/signup/* on the auth (cognito-signup) Lambda — signup payment only. */
export const postBilling = (path, body, config = {}) =>
  authBillingClient.post(path, body, config);

export { PLANS_URL as PLANS_BILLING_URL, AUTH_LAMBDA_URL };
export default plansClient;
